import { combineReducers } from 'redux';
import access from '../ducks/access';
import audiograms from '../ducks/audiograms';
import changes from '../ducks/changes';
import drafts from '../ducks/drafts';
import episodes from '../ducks/episodes';
import featureFlags from '../ducks/feature-flags';
import integrations from '../ducks/integrations';
import markers from '../ducks/markers';
import network from '../ducks/network';
import showStats from '../ducks/show-stats';
import shows from '../ducks/shows';
import user from '../ducks/user';

export default combineReducers({
  access,
  audiograms,
  changes,
  drafts,
  episodes,
  featureFlags,
  integrations,
  markers,
  network,
  shows,
  showStats,
  user,
});
